export const getAllCategories = state => state.categories || [];

export const getCategoryById = (state, categoryId) =>
  getAllCategories(state).find(c => c._id === categoryId);
